export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Registrační údaje"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uložit údaje"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrzeno"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Toto pole je veřejné a viditelné pro ostatní uživatele"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Toto pole je skryté před ostatními uživateli"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověření identity"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřeno"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Probíhá"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neověřeno"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zahájit ověření"])}
}